import React, { useState } from "react";
import "./styles.less";
import { useTranslation } from "react-i18next";
// import { useNavigate } from "react-router-dom";
import { useInterval } from "react-use";
// import classnames from "classnames";
// import { SilderDot } from "../../components/SilderDot";
import { tryNow } from "../../utils";
import { CommonConsult } from "../common-consult";

export const MainOthers = () => {
  const { t } = useTranslation();
  // const nav = useNavigate();
  const [element, setElement] = useState(1);
  // const commonList = [
  //   {
  //     common: `${t("page.other.item-one.common")}`,
  //     author: `—— ${t("page.other.item-one.author")}`,
  //     urlimg: "//files.authing.co/authing-website/home-logo-dongnan.png",
  //   },
  //   {
  //     common: `${t("page.other.item-two.common")}`,
  //     author: `—— ${t("page.other.item-two.author")}`,
  //     urlimg: "//files.authing.co/authing-website/home-logo-aws.png",
  //   },
  //   {
  //     common: `${t("page.other.item-three.common")}`,
  //     author: `—— ${t("page.other.item-three.author")}`,
  //     urlimg: "//files.authing.co/authing-website/home-logo-education.png",
  //   },
  //   {
  //     common: `${t("page.other.item-four.common")}`,
  //     author: `—— ${t("page.other.item-four.author")}`,
  //     urlimg: "//files.authing.co/authing-website/home-logo-zhijiang.png",
  //   },
  //   {
  //     common: `${t("page.other.item-five.common")}`,
  //     author: `—— ${t("page.other.item-five.author")}`,
  //     urlimg: "//files.authing.co/authing-website/home-logo-kuangxin.png",
  //   },
  //   {
  //     common: `${t("page.other.item-six.common")}`,
  //     author: `—— ${t("page.other.item-six.author")}`,
  //     urlimg: "//files.authing.co/authing-website/home-logo-toyota.png",
  //   },
  //   {
  //     common: `${t("page.other.item-seven.common")}`,
  //     author: `—— ${t("page.other.item-seven.author")}`,
  //     urlimg: "//files.authing.co/authing-website/home-logo-jcdecaux.png",
  //   },
  // ];
  const brandList = [
    {
      imgurl: "//files.authing.co/authing-website/home-logo-aws-new.png",
      alt: `authing ${t("common.logo.亚马逊")}`,
    },
    {
      imgurl: "//files.authing.co/authing-website/home-logo-aliyun-new.png",
      alt: `authing ${t("common.logo.阿里云")}`,
    },
    {
      imgurl: "//files.authing.co/authing-website/home-logo-tencent-new.png",
      alt: `authing ${t("common.logo.腾讯云")}`,
    },
    {
      imgurl: "//files.authing.co/authing-website/home-logo-huawei-new.png",
      alt: `authing ${t("common.logo.华为云")}`,
    },
    {
      imgurl: "//files.authing.co/authing-website/home-logo-tetin-new.png",
      alt: `authing ${t("common.logo.云测")}`,
    },
  ];
  // const custormList = [
  //   {
  //     imgurl: "//files.authing.co/authing-website/home-logo-cnpc-new.png",
  //     alt: `authing ${t("common.logo.中国石油")}`,
  //   },
  //   { imgurl: "//files.authing.co/authing-website/brand-state-grid.png", alt: `authing ${t("common.logo.国家电网")}` },
  //   { imgurl: "//files.authing.co/authing-website/brand-toyota-red.svg", alt: `authing ${t("common.logo.丰田")}` },
  //   {
  //     imgurl: "//files.authing.co/authing-website/brand-logo-zhaoshang.svg",
  //     alt: `authing ${t("common.logo.招商银行")}`,
  //   },
  //   {
  //     imgurl: "//files.authing.co/authing-website/home-logo-higer-new.png",
  //     alt: `authing ${t("common.logo.高等教育出版社")}`,
  //   },
  //   {
  //     imgurl: "//files.authing.co/authing-website/home-logo-dongnan-new.png",
  //     alt: `authing ${t("common.logo.东南大学")}`,
  //   },
  //   {
  //     imgurl: "//files.authing.co/authing-website/logo-sichuan-university.png",
  //     alt: `authing ${t("common.logo.华西医院")}`,
  //   },
  //   {
  //     imgurl: "//files.authing.co/authing-website/brand-logo-jcdecaux.png",
  //     alt: `authing ${t("common.logo.德高集团")}`,
  //   },
  //   { imgurl: "//files.authing.co/authing-website/home-logo-tetin-new.png", alt: `authing ${t("common.logo.云测")}` },
  //   {
  //     imgurl: "//files.authing.co/authing-website/home-logo-pand-new.png",
  //     alt: `authing ${t("common.logo.盼达用车")}`,
  //   },
  //   { imgurl: "//files.authing.co/authing-website/brand-theragun.svg", alt: `authing ${t("common.logo.THERAGUN")}` },
  //   { imgurl: "//files.authing.co/authing-website/brand-bentley.png", alt: `authing ${t("common.logo.宾利")}` },
  //   {
  //     imgurl: "//files.authing.co/authing-website/home-logo-stack-new.png",
  //     alt: `authing ${t("common.logo.stackchat")}`,
  //   },
  //   {
  //     imgurl: "//files.authing.co/authing-website/home-logo-chatopera-new.png",
  //     alt: `authing ${t("common.logo.chatopera")}`,
  //   },
  //   {
  //     imgurl: "//files.authing.co/authing-website/home-logo-tencent-new.png",
  //     alt: `authing ${t("common.logo.腾讯云")}`,
  //   },
  //   { imgurl: "//files.authing.co/authing-website/home-logo-aws-new.png", alt: `authing ${t("common.logo.亚马逊")}` },
  //   {
  //     imgurl: "//files.authing.co/authing-website/home-logo-lezhi-new.png",
  //     alt: `authing ${t("common.logo.乐智机器人")}`,
  //   },
  //   {
  //     imgurl: "//files.authing.co/authing-website/home-logo-memect-new.png",
  //     alt: `authing ${t("common.logo.文因互联")}`,
  //   },
  //   { imgurl: "//files.authing.co/authing-website/home-logo-kingdee-new.png", alt: `authing ${t("common.logo.金蝶")}` },
  //   {
  //     imgurl: "//files.authing.co/authing-website/home-logo-free-new.png",
  //     alt: `authing ${t("common.logo.freeCodeCamp")}`,
  //   },
  //   {
  //     imgurl: "//files.authing.co/authing-website/home-logo-aliyun-new.png",
  //     alt: `authing ${t("common.logo.阿里云")}`,
  //   },
  //   {
  //     imgurl: "//files.authing.co/authing-website/home-logo-juzi-new.png",
  //     alt: `authing ${t("common.logo.句子互动")}`,
  //   },
  //   {
  //     imgurl: "//files.authing.co/authing-website/home-logo-huawei-new.png",
  //     alt: `authing ${t("common.logo.华为云")}`,
  //   },
  //   {
  //     imgurl: "//files.authing.co/authing-website/home-logo-jinzheng-new.png",
  //     alt: `authing ${t("common.logo.金证优智")}`,
  //   },
  //   {
  //     imgurl: "//files.authing.co/authing-website/home-logo-unity-new.png",
  //     alt: `authing ${t("common.logo.一清创新")}`,
  //   },
  // ];
  useInterval(() => {
    if (element < 7) {
      setElement(element + 1);
    } else {
      setElement(1);
    }
  }, 8000);
  return (
    <div className="others">
      <div key="1" className="inner">
        <section className="partner-warp" style={{ marginBottom: 40 }}>
          <div className="top">
            <div className="headline">{t("page.other.title-cooperatner")}</div>
          </div>

          <div className="partner">
            {brandList.map((brand) => {
              return (
                <div className="brand">
                  <img src={brand.imgurl} alt={brand.alt} />
                </div>
              );
            })}
          </div>
        </section>
      </div>

      <section>
        <div className="brand-warp">
          <div className="inner">
            <div className="item">
              <div>
                <div className="brand">
                  <img
                    src={"//files.authing.co/authing-website/logo-iso.png"}
                    alt="authing logo iso"
                  />
                </div>
                <div className="text">{t("page.other.brand.item-one")}</div>
              </div>
            </div>
            <div className="item">
              <div>
                <div className="brand">
                  <img
                    src={"//files.authing.co/authing-website/logo-gdpr.png"}
                    alt="authing logo gdpr"
                  />
                </div>
                <div className="text">{t("page.other.brand.item-two")}</div>
              </div>
            </div>
            <div className="item">
              <div>
                <div className="brand">
                  <img
                    src={"//files.authing.co/authing-website/logo-soc.png"}
                    alt="authing logo soc"
                  />
                </div>
                <div className="text">{t("page.other.brand.item-tree")}</div>
              </div>
            </div>
            <div className="item">
              <div>
                <div className="brand">
                  <img
                    src={"//files.authing.co/authing-website/logo-djcp.png"}
                    alt="authing logo djcp"
                  />
                </div>
                <div className="text">{t("page.other.brand.item-four")}</div>
              </div>
            </div>
            <div className="item">
              <div>
                <div className="brand">
                  <img
                    src={
                      "//files.authing.co/authing-website/country-height-tech.svg"
                    }
                    alt="authing logo tech"
                  />
                </div>
                <div className="text">{t("page.other.brand.item-five")}</div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section>
        <div className="trial-warp">
          <div className="trial">
            <div className="bg-img">
              <img
                src={"//files.authing.co/authing-website/bottom-banner.jpg"}
                alt="authing trial background"
              />
            </div>
            <div>
              <div className="title" key="1">
                {t("page.other.slogn")}
              </div>
              <div key="2" className="button-warp">
                <div className="button filled" onClick={tryNow}>
                  {t("common.button.try-now")}
                </div>
                <CommonConsult
                  aside={
                    <div className="button unfilled">
                      {t("common.button.consult")}
                    </div>
                  }
                />
                {/* <div
                  key="3"
                  className="button unfilled"
                  onClick={() => {
                    nav("/pricing");
                  }}
                >
                  {t("common.button.consult")}
                </div> */}
              </div>
            </div>
          </div>
          <div className="bg-color"></div>
        </div>
      </section>
    </div>
  );
};
